import { render, staticRenderFns } from "./TypeDocument.vue?vue&type=template&id=25043248&"
import script from "./TypeDocument.vue?vue&type=script&lang=js&"
export * from "./TypeDocument.vue?vue&type=script&lang=js&"
import style0 from "./TypeDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports